import React, { useEffect, useRef } from 'react';
import { natureBg } from '../mock';
import { Heart } from 'lucide-react';

const NatureBanner = () => {
  const ref = useRef(null);

  useEffect(() => {
    const els = ref.current?.querySelectorAll('.reveal');
    if (!els) return;
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add('is-visible')),
      { threshold: 0.15 }
    );
    els.forEach((el) => obs.observe(el));

    // Parallax effect
    const onScroll = () => {
      if (!ref.current) return;
      const rect = ref.current.getBoundingClientRect();
      const img = ref.current.querySelector('.parallax-img');
      if (img) {
        const offset = rect.top * 0.15;
        img.style.transform = `translateY(${offset}px) scale(1.15)`;
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      obs.disconnect();
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  return (
    <section ref={ref} className="relative h-[60vh] md:h-[70vh] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={natureBg.waterfall}
          alt="Lush forest with cascading waterfall"
          className="parallax-img w-full h-full object-cover will-change-transform"
          loading="lazy"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-[#2c3f25]/40 via-[#3a5232]/30 to-[#2c3f25]/60" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_transparent_30%,_rgba(44,63,37,0.5)_100%)]" />
      </div>

      <div className="relative z-10 h-full flex items-center justify-center px-5">
        <div className="text-center max-w-3xl reveal">
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="h-px w-12 bg-[#d8e0b0]" />
            <Heart size={18} className="text-[#d8e0b0] fill-[#d8e0b0]/30" />
            <span className="h-px w-12 bg-[#d8e0b0]" />
          </div>
          <p className="font-script text-3xl md:text-5xl text-[#f0e9d2] drop-shadow-lg">
            In nature, we find our calm.
          </p>
          <h2 className="font-serif text-3xl md:text-5xl lg:text-6xl text-white mt-4 leading-tight tracking-tight drop-shadow-xl">
            Healing flows naturally, <br /> just like a quiet stream.
          </h2>
          <p className="mt-6 text-[#e8e3d2] text-base md:text-lg max-w-xl mx-auto leading-relaxed">
            Every conversation is a gentle step toward peace.
            Reconnect with yourself in a space inspired by nature&apos;s steady rhythm.
          </p>
          <a
            href="#contact"
            className="inline-block mt-8 px-8 py-3.5 rounded-full bg-[#f0e9d2] text-[#2c3f25] text-sm font-medium hover:bg-white hover:-translate-y-0.5 transition-all duration-300 shadow-lg"
          >
            Begin your journey
          </a>
        </div>
      </div>
    </section>
  );
};

export default NatureBanner;
